import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import api from "../../services/api";
import { formatPhone } from "../../utils/formatPhone";
import { useMenuStyles } from "../menuStyles";

// Seletor reutilizável de número da conta (tela Numbers) para qualquer campo de
// CallerId / "origem". Evita digitar número à mão (e o anti-spoofing rejeitar).
// `value`/`onChange` trabalham com o número cru (ex.: "1930950000").
const NumberSelect = ({
  value,
  onChange,
  label = "Número de origem (Caller ID)",
  helperText,
  size = "small",
  fullWidth = true,
  disabled,
  style,
  allowEmpty = false, // mostra opção "(padrão)" para callerId opcional
  emptyLabel = "(padrão)",
}) => {
  const menuCls = useMenuStyles();
  const [numbers, setNumbers] = useState([]);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/numbers");
        if (alive) setNumbers(data.numbers || []);
      } catch {
        /* silencioso */
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  return (
    <TextField
      select
      SelectProps={{
        // dropdown no padrão de menu do app (ver memória "menu-modal-design-pattern")
        MenuProps: {
          classes: { paper: menuCls.selectPaper },
          getContentAnchorEl: null,
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
        },
      }}
      label={label}
      value={value || ""}
      onChange={e => onChange(e.target.value)}
      size={size}
      fullWidth={fullWidth}
      variant="outlined"
      disabled={disabled}
      style={style}
      helperText={helperText || (numbers.length === 0 ? "Nenhum número na conta — adicione em Números." : undefined)}
    >
      {allowEmpty && <MenuItem value="">{emptyLabel}</MenuItem>}
      {!allowEmpty && numbers.length === 0 && <MenuItem value="">(nenhum número)</MenuItem>}
      {/* permite manter um valor legado que não esteja na lista */}
      {value && !numbers.some(n => n.number === value) && (
        <MenuItem value={value}>{formatPhone(value)}</MenuItem>
      )}
      {numbers.map(n => (
        <MenuItem key={n.id} value={n.number}>
          {formatPhone(n.number)}
          {n.city ? ` · ${n.city}` : ""}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default NumberSelect;
